import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UpdateEntitiesTasksRelationMutationVariables = Types.Exact<{
  input: Types.UpdateEntitiesTasksRelationInput;
}>;


export type UpdateEntitiesTasksRelationMutation = { updateEntitiesTasksRelation?: { success?: boolean | null } | null };


export const UpdateEntitiesTasksRelationDocument = /*#__PURE__*/ gql`
    mutation updateEntitiesTasksRelation($input: UpdateEntitiesTasksRelationInput!) {
  updateEntitiesTasksRelation(data: $input) {
    success
  }
}
    `;

export function useUpdateEntitiesTasksRelationMutation() {
  return Urql.useMutation<UpdateEntitiesTasksRelationMutation, UpdateEntitiesTasksRelationMutationVariables>(UpdateEntitiesTasksRelationDocument);
};